// src/redux/EditPropertySlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import i18n from "../../i18n/i18n";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const editProperty = createAsyncThunk(
  "edit_property/submit",
  async ({id,data}, { rejectWithValue }) => {
    try {
      const token = JSON.parse(sessionStorage.getItem("user3ayin"))?.token;
      const response = await axios.post(`${BASE_URL}/api/properties/update/${id}`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
          Lang: i18n.language,
        },
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(
    err.response?.data || { message: "Failed to submit property form" }
  );
    }
  }
);

// Initial state
const initialState = {
  loadingProperty: false,
  updateProperty: null,
  failedUpdateProperty: null,
};

// Slice
const EditPropertySlice = createSlice({
  name: "edit_property",
  initialState,
  reducers: {
    clearState: (state) => {
      state.loadingProperty = false;
      state.updateProperty = null;
      state.failedUpdateProperty = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(editProperty.pending, (state) => {
        state.loadingProperty = true;
        state.failedUpdateProperty = null;
        state.updateProperty = null;
      })
      .addCase(editProperty.fulfilled, (state, action) => {
        state.loadingProperty = false;
        state.updateProperty = true;
      })
      .addCase(editProperty.rejected, (state, action) => {
        state.loadingProperty = false;
        state.updateProperty = false;
        state.failedUpdateProperty = action.payload || action.failedUpdateProperty?.message || "Something went wrong";
      });
  },
});

// Exports
export const { clearState } = EditPropertySlice.actions;
export default EditPropertySlice.reducer;
